"use client";

import { useRouter, useSearchParams } from "next/navigation";

export const useQueryState = <T extends string>(
	key: string,
	initialState: T,
	{ shallow = true, replace = false } = {},
) => {
	const router = useRouter();
	const searchParams = useSearchParams();

	const val = searchParams.get(key);

	const setValue = (value: T | ((arg: T) => T)) => {
		const newParams = new URLSearchParams(searchParams.toString());
		const newValue = typeof value === "function" ? value((val as T) || initialState) : value;
		if (!newValue) {
			newParams.delete(key);
		} else {
			newParams.set(key, newValue);
		}

		const newUrl = `${window.location.pathname}?${newParams.toString()}`;

		if (shallow) {
			if (replace) {
				window.history.replaceState({}, "", newUrl);
			} else {
				window.history.pushState({}, "", newUrl);
			}
		} else {
			if (replace) {
				router.replace(newUrl);
			} else {
				router.push(newUrl);
			}
		}
	};

	return [val ?? initialState, setValue] as const;
};
